import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={54}
    height={48}
    {...props}
  >
    <defs>
      <style>{".cls-15{fill:#060b0c}"}</style>
    </defs>
    <g id="Palette">
      <path
        d="M27 12.5c6.3 0 11.5 5.2 11.5 11.5S33.3 35.5 27 35.5 15.5 30.3 15.5 24 20.7 12.5 27 12.5m0-2c-7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5 13.5-6 13.5-13.5-6-13.5-13.5-13.5Z"
        className="cls-15"
      />
      <path
        d="M27 8c9.7 0 18.6 5.8 24.7 16-6.1 10.2-15 16-24.7 16S8.4 34.2 2.3 24C8.4 13.8 17.3 8 27 8m0-2C16 6 6.2 13.1 0 24c6.2 10.9 16 18 27 18s20.8-7.1 27-18C47.8 13.1 38 6 27 6Z"
        className="cls-15"
      />
      <path
        d="M0 0h54v48H0z"
        style={{
          fill: "none",
        }}
      />
    </g>
  </svg>
)
export default SvgComponent
